import React, { Component, PureComponent, Fragment } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Logo } from '../common/logo'

export default function ApproveHeader(props) {
  let {
    groups: materialGroups,
    groupId,
    nextGroup,
    changeGroup,
    approves,
    submitted,
    validationError,
    consentError,
    t,
  } = props

  let groups = [
    {
      items: materialGroups.get('video', List()),
      id: 'video',
      icon: 'film',
    },
    {
      items: materialGroups.get('image', List()),
      id: 'image',
      icon: 'image',
    },
    {
      items: materialGroups.get('article', List()),
      id: 'article',
      icon: 'file',
    },
  ]

  let index = 0

  return (
    <div className="approve-header">
      {!groupId ? (
        <div className="approve-header-container">
          <div className="approve-header-container-action approve-header-container-action--left"></div>
          <div className="approve-header-logo">
            <Logo />
          </div>
          <div className="approve-header-container-action approve-header-container-action--right"></div>
        </div>
      ) : groupId === 'final' ? (
        <div className="approve-header-container">
          <div className="approve-header-container-action approve-header-container-action--left">
            {!submitted ? (
              <button onClick={e => e.preventDefault() & changeGroup(nextGroup)}>
                <span>{t('approve.header.back')}</span>
              </button>
            ) : null}
          </div>
          <div className="approve-header-logo approve-header-notification-wrapper">
            {submitted ? (
              <Logo />
            ) : (
              <div className="approve-header-notification">
                <i className="fa fa-exclamation-triangle" />
                {t('approve.unsavedChanges')}
              </div>
            )}
          </div>
          <div className="approve-header-container-action approve-header-container-action--right"></div>
        </div>
      ) : (
        <div className="approve-header-container approve-header-container--actions">
          <div className="approve-header-container-action approve-header-container-action--left">
            <button onClick={e => e.preventDefault() & changeGroup(false)}>
              <span>{t('approve.header.back')}</span>
            </button>
          </div>
          <div className="approve-header-container-action approve-header-container-action--center">
            <div className="approve-header-status-wrapper">
              {groups.map(({ title, items, icon, id }, key) => {
                if (!items.size) return null

                let classes = ['approve-header-status']
                if (id === groupId) classes.push('approve-header-status--active')

                if (approves.get(id) === true) classes.push('approve-header-status--approve-yes')

                if (approves.get(id) === false) classes.push('approve-header-status--approve-no')

                index++

                return (
                  <span className={classes.join(' ')} key={key}>
                    <div className="approve-header-status-icon">
                      <span>{approves.has(id) ? <i className={`fa fa-check`} /> : <b>{index}</b>}</span>
                    </div>
                  </span>
                )
              })}
            </div>
          </div>
          <div className="approve-header-container-action approve-header-container-action--right"></div>
        </div>
      )}
      {validationError ? (
        <div className="approve-header-validation-error">{t('approve.validationError')}</div>
      ) : consentError ? (
        <div className="approve-header-validation-error">{t('approve.consentError')}</div>
      ) : null}
    </div>
  )
}
